<div
  class="border-surface-300 font-family-din rounded-sm border-2 p-4 text-center text-4xl transition-colors select-none"
  [class]="{
    'bg-white': !disabled(),
    'bg-slate-100': disabled(),
    'text-text-primary': !disabled(),
    'text-slate-300': disabled(),
  }"
>
  {{ klank() }}
</div>
